import { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { useForm } from 'react-hook-form'
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from 'react-query'
import { ValidationSchema } from "../services/schemaValidation";
import { ValidateErrorMessage } from "components/ValidateErrorMessage";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { save } from "../services/api";
import FormBuilder from "components/Inputs/FormBuilder";
import { DataFields } from "./DataFields";
import { useTranslation } from "react-i18next";
import ImageManager from "components/ImageManager";

export default function Add({ open, close, menu, category, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [dataInstance, setDataInstance] = useState({})
  const [imageManagerModalOpen, setImageManagerModalOpen] = useState(false)
  const [dataFieldImageManager, setDataFieldImageManager] = useState(null)
  let { reset, handleSubmit, register, formState: { errors }, setValue }  = useForm({ 
    resolver: yupResolver(ValidationSchema)
  })

  const mutation = useMutation(save, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { reportAction(false, 'Error al guardar los datos', 'error')
      } else { reportAction(true, 'Acción realizada correctamente', 'success') }
    }
  })

  const handleAdd = (params) => { 
    //console.log("prueba", params)
    params.category = category
    const formData = new FormData()
    for (const key in params) {
      if (key === 'image') {
        if(Array.isArray(params.image)) {
          formData.append("image", params.image[0].file)
        } else {
          formData.append("image", params.image)
        }
      } else {
        formData.append(key, params[key])
      }
    }
    for (var pair of formData.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    }
    setIsLoading(true)
    mutation.mutate(formData)
  }
  
  const handleClose = () => { reset(); setDataInstance({}); close() }

  const handleOnChangeData = (event) => { 
    if(event.target.name.includes(".")) {
      const separate = event.target.name.split(".")
      setDataInstance({ ...dataInstance, [separate[0]]: { ...dataInstance[separate[0]], [separate[1]]: event.target.value } })
      return;
    }
    setDataInstance({ ...dataInstance, [event.target.name]: event.target.value })
  }

  const handleChangeBoolean = (name) => {
    setDataInstance({...dataInstance, [name]: !dataInstance[name]}) 
  }

  /*Handlers Image manager */
  const handleOpenImageManager = () => { setImageManagerModalOpen(true) }  
  const handleCloseImageManager = ( prop ) => { setImageManagerModalOpen(prop) }
  const handleFieldImageManager = ( prop ) => { setDataFieldImageManager(prop) }  
  const handleSelectImageManager = (url) => {
    setDataInstance({...dataInstance, [dataFieldImageManager]: url})
    setValue(dataFieldImageManager, url)
  }

  const Actions = () => (<>
    { !isLoading ? <>
      <Button onClick={handleClose}>{t('button_text_cancel')}</Button>
      <Button variant="contained" color="info" onClick={handleSubmit(handleAdd)}>{t('button_text_add')}</Button>
      </> : <CircularProgress /> }
  </>)

  return (<>
    <FlexibleWidthDialog open={open} title={t('builder_subcategories_dialog_title_add')} actions={<Actions />}>
      <>
        <input type="hidden" name="category" {...register(`category`)} value={category}/>
        <ValidateErrorMessage message={errors.menu?.message} />
        <FormBuilder
          dataDields={DataFields(t)}
          dataInstance={dataInstance}
          containerSelectOptions={{ presentations: [{value: 0, label: "Comida"}, {value: 1, label: "Bebidas"}] }}
          register={register}
          errors={errors}
          changeDataFunction={handleOnChangeData}
          changeDataBoolean={handleChangeBoolean}
          openImageManager={handleOpenImageManager}
          setFieldImageManager={handleFieldImageManager} />
      </>
    </FlexibleWidthDialog>
    <ImageManager
      open={imageManagerModalOpen}
      actionClose={handleCloseImageManager}
      multipleImages={false}
      setImages={handleSelectImageManager} />
  </>)
}